{
  "LetsGetStarted": "Ready to turn your ideas into reality? Let's get started!",
  "CreateFirstProject": "Create My First Project",
  "NeedToFirstCreateProject": "You need to create a project first in order to start a builder.",
  "WouldYouLikeToCreate": "Would you like to create one now?",
  "CreateNewProject": "Create New Project",
  "MarkAsRead": "Mark all as read",
  "ExploreBuildersTooltip": "Explore Builders to help bring your ideas to life",
  "ExploreProjectsTooltip": "Get Inspired by other people's projects",
  "MyGroupBuildersTooltip": "Keep track of the builders assigned to you in a hub group",
  "MyGroupBuilderScheduleTooltip": "Keep track of the builder schedule that you assigned to the hub group as an admin/manager.",
  "MyBuildersTooltip": "Keep track of the builders you are working on",
  "textOne": "Create your first project to start exploring RebelBase. From there, you can collaborate, interact, team up, and share ideas with other Rebels.",
  "textTwo": "You’ll begin by working through the Builders and Workshops across the platform, and break down barriers of all shapes and sizes.",
  "textThree": "Don’t worry if you aren’t sure what type of project you want to build just yet. Start with an idea, and we’ll help you refine it - or join existing teams and projects.",
  "ReadyToTurnIdeasToReality": "Ready to turn your ideas into reality? Let’s get started!",
  "InnovationCannotWait": "Innovation can’t wait–create your first project and see what we can build together!",
  "SkipForNow": "Skip for now"
}
